enum ServiceTicketStatusEnum {
	Open = 'open',
	Pending = 'pending',
	Planned = 'planned',
	Ready = 'ready',
	Closed = 'closed',
}

export default ServiceTicketStatusEnum;
